(function () {
  'use strict';
  function initBookingEngine() {
    var dateSelect = document.getElementById('zd-date-select');
    var addToCartBtn = document.getElementById('zd-add-to-cart');
    var dataEl = document.getElementById('zd-products-data');
    if (!dateSelect || !dataEl) return;
    var products = [];
    try { products = JSON.parse(dataEl.textContent); } catch (e) {}
    dateSelect.addEventListener('change', function () {
      var id = parseInt(this.value, 10);
      var product = products.find(function (p) { return p.id === id; });
      if (product) updateBookingUI(product);
      if (addToCartBtn) addToCartBtn.disabled = !this.value;
    });
    if (addToCartBtn) addToCartBtn.addEventListener('click', function () { addToCart(); });
    document.querySelectorAll('.zd-gallery__thumb').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var mainImg = document.querySelector('.zd-gallery__main img');
        var thumbImg = thumb.querySelector('img');
        if (mainImg && thumbImg) { var tmp = mainImg.src; mainImg.src = thumbImg.src; thumbImg.src = tmp; }
      });
    });
    initCarousel('.zd-experiences-carousel', '.zd-exp-prev', '.zd-exp-next');
    initCarousel('.zd-ugc-carousel', '.zd-ugc-prev', '.zd-ugc-next');
    document.querySelectorAll('.zd-accordion-trigger').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.zd-accordion-item');
        if (!item) return;
        var isOpen = item.classList.contains('is-open');
        document.querySelectorAll('.zd-accordion-item.is-open').forEach(function (el) { el.classList.remove('is-open'); });
        if (!isOpen) item.classList.add('is-open');
      });
    });
    if (dateSelect.options.length > 1) { dateSelect.selectedIndex = 1; dateSelect.dispatchEvent(new Event('change')); }
  }
  function updateBookingUI(product) {
    setText('zd-duration', product.days + ' días');
    setText('zd-nights', product.nights + ' noches');
    setText('zd-spots-text', product.inventory + ' lugares disponibles');
    setText('zd-full-price', '$' + fmt(product.price) + ' USD');
    setText('zd-deposit-price', '$' + fmt(product.deposit) + ' USD');
    if (product.numPagos > 0 && product.montoPago > 0) {
      setText('zd-installments', '+ ' + product.numPagos + ' pagos diferidos de $' + fmt(product.montoPago) + ' USD');
    } else { setText('zd-installments', ''); }
    window.zdCurrentProduct = product;
  }
  function setText(id, text) { var el = document.getElementById(id); if (el) el.textContent = text; }
  function fmt(num) { var n = parseFloat(num); if (isNaN(n)) return '0'; return n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function getSelectedVariantId() {
    var product = window.zdCurrentProduct; if (!product) return null;
    var radio = document.querySelector('input[name="zd_payment_type"]:checked');
    var type = radio ? radio.value : 'full';
    return type === 'deposit' ? product.depositVariantId : product.fullVariantId;
  }
  async function addToCart() {
    var variantId = getSelectedVariantId(); if (!variantId) return;
    var btn = document.getElementById('zd-add-to-cart');
    if (btn) { btn.disabled = true; btn.textContent = 'Agregando...'; }
    try {
      var res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] }) });
      if (!res.ok) throw new Error('Cart error');
      // Ir al carrito: ahi la app de recargo aplica el "Cargo por pago en linea" antes de pagar
      window.location.href = '/cart';
    } catch (e) {
      console.error('Zondela cart:', e);
      alert('No se pudo agregar al carrito. Intenta de nuevo.');
      if (btn) { btn.disabled = false; btn.textContent = 'Reservar mi viaje'; }
    }
  }
  function initCarousel(trackSel, prevSel, nextSel) {
    var track = document.querySelector(trackSel);
    var prevBtn = document.querySelector(prevSel);
    var nextBtn = document.querySelector(nextSel);
    if (!track) return;
    if (prevBtn) prevBtn.addEventListener('click', function () { track.scrollBy({ left: -300, behavior: 'smooth' }); });
    if (nextBtn) nextBtn.addEventListener('click', function () { track.scrollBy({ left: 300, behavior: 'smooth' }); });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', initBookingEngine); } else { initBookingEngine(); }
})();
